import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';

import UserAvatar from '../front/UserAvatar';

const ShareBoxIcons = (props) => {
	const nets = ['facebook', 'twitter', 'whatsapp', 'email'];
	const img_size = 32;

	return (
		<>
			{nets.map((net) => {
				return (
					<ActionLink
						key={`net_${net}`}
						style={{
							display:'inline-block',
							width:`${img_size}px`,
							height:`${img_size}px`,
							marginRight:'5px',
						}}
					>
						<img
							src={`${window.public_url}/img/emails/logo_${net}.jpg`}
							width={img_size}
							height={img_size}
							border="0"
							alt=""
						/>
					</ActionLink>
				)
			})}
		</>
	)
};

const DEFAULT_MAIL_P_STYLES = 'font-size:14px; line-height:20px; margin:0 0 16px;';
const DEFAULT_MAIL_A_STYLES = 'font-size:0.9em; margin-left:5px;';
const fake_prize_id = '1234567890';
const fake_hash = 'abcdefghijklmnopqrstuvxyz';
const fake_code = "123456";

const PreviewEmail = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion ?? {};
	const prizes = props?.prizes ?? [];
	const stage = props?.stage ?? {};
	const account_first_name = window?.account_first_name ?? "[FIRST NAME]";
	const account_last_name = window?.account_last_name ?? "[LAST NAME]";
	const account_name = window?.account_name ?? `${account_first_name} ${account_last_name}`;
	const account_email = window?.account_email ?? "yourname@your-domain.com";
	const subject = props?.subject ?? `[${i18n("No subject")}]`;
	const configuration = props?.configuration ?? {};

	const fakeGalleriesLink = () =>{
		return `<a href="${window.public_url}gallery/12345678/12345679" style="${DEFAULT_MAIL_A_STYLES}">${window.public_url}gallery/12345678/12345679</a>`;
	};
	
	const prizeName = () =>{
		let prize_types = prizes;
		let html = '';
		
		prize_types.map((pt) => {
			const _prize_type = pt?.PrizeType ?? pt;
			if(props.default_prize_id && props.default_prize_id != (_prize_type.id)) return;

			html += _prize_type?.title ?? "Unknown";
		});

		return html;
	};

	const prizeSummary = () =>{
		let prize_types = prizes;
		let html = '';
		
		prize_types.map((pt) => {
			if(props.default_prize_id && props.default_prize_id != pt.PrizeType.id) return;

			html += `<br /><hr style="margin-bottom:5px;" />`;
			html += `<h3 style="margin-bottom:0px; display:inline-block;">${pt.PrizeType.title}</h3>`;

			let linkTocoupon = '';
			switch(pt.PrizeType.downloadable) {
				case 'coupon_maker':
					linkTocoupon = `prize_coupon/${pt.PrizeType.promotion_id}/${fake_hash}`;
					break;

				case 'download':
					linkTocoupon = `prize_coupon/${pt.PrizeType.promotion_id}/${fake_hash}`;
					break;

				case 'upload':
					linkTocoupon = `prize_coupon/${pt.PrizeType.promotion_id}/${fake_hash}`;
					break;
			}

			html += `<a href="${window.public_url}${linkTocoupon}" style="${DEFAULT_MAIL_A_STYLES}">[${i18n("Download")}]</a>`;

			if(pt.PrizeType.redeemable) {
				html += `<a href="${window.public_url}redeem/${pt.PrizeType.promotion_id}/${fake_hash}" style="${DEFAULT_MAIL_A_STYLES}">[${i18n("***Redeem")}]</a>`;
			}

			if(pt.PrizeType.claimable) {
				html += `<a href="${window.public_url}my_prizes/${pt.PrizeType.promotion_id}/${fake_hash}" style="${DEFAULT_MAIL_A_STYLES}">[${i18n("Claim")}]</a>`;
			}

			html += '</h3>';

			if(pt.PrizeType.description != ''){
				html += `<p style="${DEFAULT_MAIL_P_STYLES}">${pt.PrizeType.description}</p>`;
			}

			/*if(pt.PrizeType.qr_validation || (pt.PrizeType.type == 0 && pt.PrizeType.redeemable)) {
				html += `<p><a href="${window.public_url}qrcode/${fake_prize_id}/${fake_hash}" style="text-align:center;display:inline-block;margin-top:5px;"><img class="autoimg" src="${window.public_url}img/codes/qr_view.jpg" style="height:100px;margin-bottom:5px;display:block;"/>${i18n("View")}</a></p>`;
			}*/

			if(pt.PrizeType.code_set || (pt.PrizeType.type == 0 && pt.PrizeType.redeemable) || pt.PrizeType.unique_code != undefined) {
				html += `<p style="${DEFAULT_MAIL_P_STYLES}">${getPromotionalCode(pt, props.codesets)}</p>`;
			}
		});

		return html;
	};

	const getPromotionalCode = (pt, cs) => {
		let html = '';
		if(pt['PrizeType']['type'] == 1) {
			const found_cs = cs.find((c) => c.CodeSet.id == pt.PrizeType.code_set);
			html += `<strong>${i18n("Code")}</strong>: ${fake_code}`;
			if(found_cs.CodeSet.code_type) {
				html += `<br /><a href="${window.public_url}view_code/${fake_prize_id}/${fake_hash}" style="text-align:center; display:inline-block; margin-top:5px;"><img class="autoimg" src="${window.public_url}img/codes/${found_cs.CodeSet.code_type}_view.jpg" style="height:100px; margin-bottom:5px; display:block;" />${i18n("View code")}</a>`;
			}

			if(pt.PrizeType.unique_code) {
				html += `<strong>${i18n("Code")}</strong>: ${pt.PrizeType.unique_code}`;
			} else if(pt['PrizeType']['type'] == 0 && pt.PrizeType.redeemable) {
				html += `<strong>${i18n("Code")}</strong>: ${fake_prize_id}`;
			}
		}

		return `<p style="${DEFAULT_MAIL_P_STYLES}">${html}</p>`;
	};

	const generic_replaces = [{
		tag:'user_first_name',
		value:account_first_name,
	}, {
		tag:'user_last_name',
		value:account_last_name,
	}, {
		tag:'user_email',
		value:account_email,
	}, {
		tag:'promo_title',
		value:promotion.title,
	}, {
		tag:'user_access_link',
		value:`${window.public_url}promotions/participate/${promotion.id}?lt=abcdefghijklmnopqrstuvwxyz`,
	}, {
		tag:'promo_link',
		value:`${window.public_url}p/${promotion.id}`,
	}, {
		tag:'user_nickname',
		value:"[NICKNAME]",
	}, {
		tag:'user_source',
		value:"utm_source",
	}, {
		tag:'participation_score',
		value:"1234.56",
	}, {
		tag:'prize_summary',
		value:prizeSummary,
	}, {
		tag:'prize_code',
		value:"[CODE]",
	}, {
		tag:'prize_name',
		value:prizeName,
	}, {
		tag:'prize_instructions',
		value:"- Instruction nº1<br/>- Instruction nº2",
	}, {
		tag:'quiz_summary',
		value:"[QUIZ SUMMARY]",
	}, {
		tag:'user_information',
		value:"[ALL USER INFORMATION]",
	}, {
		tag:'user_voteme_url',
		value:`${window.public_url}gallery/${promotion.id}/${stage.id}/12345678`,
	}, {
		tag:'claim_prize_url',
		value:`${window.public_url}${(promotion.promotion_type_id == '42' ? 'prizes/claim' : 'my_prizes' )}/${promotion.id}/12345678?ct=abcdefghijklmnopqrstuvwxyz&lid=1234567`,
	}, {
		tag:'prize_attachment_link',
		value:`${window.public_url}prizes/attachment/12345678/abcdefghijklmnopqrstuvwxyz`,
	}, {
		tag:'share_voteme_url',
		value:<ShareBoxIcons />,
	}, {
		tag:'validation_site',
		value:'[VALIDATION POINT NAME]',
	}, {
		tag:'entry_gallery_link',
		value:fakeGalleriesLink,
	}, {
		tag:'voted_entry_link',
		value:fakeGalleriesLink,
	}, {
		tag:'voted_entry_name',
		value:account_name,
	}];

	const replaceSmartTagsTest = (text) => {
		text = (text).replace(/\n/gi, "<br />");
		generic_replaces.map((obj) => {
			const rg = new RegExp('\{\{' + obj.tag + '\}\}', "g");
			text = text.replace(rg, obj.value);
		});

		return text;
	};

	const email_info = promotion?.email_config ?? {};	//Only Fluxe 1

	if(configuration.fromname != undefined && configuration.fromname != '') {
		email_info.fromname = configuration.fromname;
	} else if(promotion.email_fromname != undefined) {
		email_info.fromname = promotion.email_fromname;
	}

	if(configuration.replyto != undefined && configuration.replyto != '') {
		email_info.replyto = configuration.replyto;
	} else if(promotion.email_replyto != undefined) {
		email_info.replyto = promotion.email_replyto;
	}

	if(promotion.email_signature != undefined) {
		email_info.signature = promotion.email_signature;
	}

	if(promotion.email_top_image != undefined) {
		email_info.full_imagetop = promotion?.full_email_top_image || promotion.email_top_image;
		email_info.imagetop = email_info.full_imagetop;
	}

	if(promotion.email_top_image != undefined){
		email_info.full_imagebottom = promotion?.full_email_bottom_image || promotion.email_bottom_image;
		email_info.imagebottom = email_info.full_imagebottom;
	}

	let colors = promotion?.email_colors || {};
	if(Object.keys(colors).length == 0) {
		colors = email_info?.colors || colors;
	}

	const body_styles = {};
	if(colors.layout) body_styles.background = colors.layout;
	if(colors.text) body_styles.color = colors.text;

	const link_color = colors?.link ?? '#2330be'
	const button_bkg = colors?.button ?? '#2330be'
	const button_text = colors?.text_button ?? '#ffffff'
	
	const css_links = `
.email_c a,
.email_c a:link,
.email_c a:visited,
.email_c a:active,
.email_c a:hover {
	font-weight:normal;
	color:${link_color};
	text-decoration:none;
	word-break:break-word;
}

.email_c a:active,
.email_c a:hover {
	text-decoration:underline;
}

.email_c a.button,
.email_c a.button:hover {
	margin-top:15px;
	border-radius:5px;
	padding:10px 20px;
	color:${button_text} !important;
	text-decoration:none;
	display:inline-block;
	background-color:${button_bkg};
}

.email_c a.button * {
	color:${button_text} !important;
}`;

	const container_styles = {};
	if(colors.body) container_styles.background = colors.body;
	if(colors.text) container_styles.color = colors.text;

	const sender_name = (isNotEmpty(email_info, 'fromname')) ? email_info.fromname : "[Easypromos]";
	const by_email_platform = props?.by_email_platform ?? true;
	return (
		<div id="email_preview" class="gui_preview_email not_awesome gui_custom_font">
			<aside class="email_header">
				<div>
					<p class="from_field"><strong>{sender_name}</strong></p>

					<p class="subject_field" dangerouslySetInnerHTML={{ __html:replaceSmartTagsTest(subject) }} />

					<p class="to_field">{i18n("to", 'ucfirst')}: <span>{account_first_name} {account_last_name}</span></p>

					{(email_info.replyto != undefined && email_info.replyto != "") && (
						<p class="replyto_field">{i18n("Reply to")}: <span>{email_info.replyto}</span></p>
					)}
				</div>

				<div class="header_sidebar">
					<p class="time_field"><span>{EPDateFormat(null, 'HH:mm')}</span></p>

					<UserAvatar
						user={{ first_name:sender_name, last_name:"" }}
						width={3.5}
						height={3.5}
					/>
				</div>
			</aside>

			<section class="email_body" style={body_styles}>
				<article class="email_container" style={container_styles}>
					{(by_email_platform && email_info.imagetop != undefined && email_info.full_imagetop != undefined && email_info.full_imagetop != "") && (
						<img src={email_info.full_imagetop} width="100%" alt="" />
					)}
					<style>{css_links}</style>
					<div class="email_c" dangerouslySetInnerHTML={{ __html:replaceSmartTagsTest(props.children) }} />

					{(by_email_platform && email_info.signature != undefined && email_info.signature != "") && (
						<p class="email_signature" dangerouslySetInnerHTML={{ __html:replaceSmartTagsTest(email_info.signature) }} />
					)}

					{(by_email_platform && email_info.imagebottom != undefined && email_info.full_imagebottom != undefined && email_info.full_imagebottom != "") && (
						<img src={email_info.full_imagebottom} width="100%" alt="" />
					)}

					{(by_email_platform && promotion.promo_type != '2') && (
						<p class="ep_footer_link"><FormattedMessage id="Made with {ep}" values={{ep:<ActionLink _class={{other:'whiteColor'}}>Easypromos</ActionLink>}} /></p>
					)}
					
					{(by_email_platform && isNotEmpty(promotion,'email_disclaimer',[''])) && (
						<p class="email_body" style={{fontSize:'8pt', lineHeight:'11pt',color:'#363636',padding:'5px 8px', textAlign:'center'}} dangerouslySetInnerHTML={{ __html:((promotion.email_disclaimer).replace(/\n/g, '<br />')) }} />
					)}
				</article>
			</section>
		</div>
	)
}

export default injectIntl(PreviewEmail);